import { combineReducers } from '@reduxjs/toolkit';
import customerSlice from './customer/customerSlice';
import companySlice from './company/companySlice';

const customersSlice = combineReducers({
    customer: customerSlice,
    company: companySlice,
});

export default customersSlice;
